import { useLocation, useMatch, useNavigate } from "react-router-dom";
import { list1RoutesCombined, list2Routes, list2RoutesCombined, list3RoutesCombined } from "./ListAndDetailSamplesMultipleListsNavigation";
import { useEffect, useState } from "react";
import { PageDefaultSegment, isMobileView, ListAndDetail } from "@sis/react-library";
import { list1Data, list2Data, List2ItemDto } from "./ListItemDto";
import { Box, Button } from "@mui/material";
import { ListAndDetailSamplesMultipleListHeadingContainer } from "./ListAndDetailSamplesMultipleListHeadingContainer";
import { listAndDetailSamplesRoutes } from "../../ListAndDetailSamplesNavigation";
import { getMatch } from "./listAndDetailSamplesMultipleListFunctions";

export const ListAndDetailSamplesMultipleList1EditPage = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = isMobileView();

  // This page could match on multiple items, loop through all of them until one matches
  const matchEdit1 = useMatch(list1RoutesCombined().list_editMatch);
  const matchEdit2 = useMatch(list2RoutesCombined().list_editMatch);
  const matchEdit3 = useMatch(list3RoutesCombined().list_editMatch);
  const matchNew1 = useMatch(list2RoutesCombined().new);
  const matchNew2 = useMatch(list3RoutesCombined().new);

  const match = getMatch([matchEdit1, matchEdit2, matchEdit3, matchNew1, matchNew2]);
  const code1 = match?.params.code1;

  // Used to collapse list when third list selected
  const [fireCollapse, setFireCollapse] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    // If the user has clicked third list, collapse this one
    if (matchEdit2 === null && !location.pathname.includes(list2Routes.new)) {
      setFireCollapse(true);
    }
    // We only want for matchEdit
    // eslint-disable-next-line
  }, [matchEdit2])

  useEffect(() => {
    // Once fireCollapse is triggered, set it back to undefined
    if (fireCollapse !== undefined) {
      setFireCollapse(undefined);
    }
  }, [fireCollapse])


  const list1Item = list1Data.find((l1) => l1.code1 === code1);

  const handleClose = () => {
    navigate(listAndDetailSamplesRoutes.multipleLists);
  }

  const list2ItemRender = (item : List2ItemDto) => <>{item.description}</>;

  return (
    <ListAndDetailSamplesMultipleListHeadingContainer
      widthOffset={14}
      heading={
        <Box>
          <b>{list1Item ? `Edit item: ${list1Item.description}` : 'New item'}</b>
          <Button
            variant="contained"
            onClick={handleClose}
            sx={{ height: '24px', marginLeft: '20px' }}
          >
            Close
          </Button>
        </Box>
      }
    >
      <Box
        sx={{
          paddingTop: isMobile ? '0' : '52px',
          paddingLeft: isMobile ? '1px' : '14px',
          paddingRight: isMobile ? '1px' : undefined
        }}
      >
        {code1 &&
          <ListAndDetail
            id="list2"
            items={list2Data}
            keyValue={(item) => item.code2}
            itemRender={list2ItemRender}
            searchFields={['description']}
            listUrl={list2RoutesCombined(code1).list}
            newUrl={list2Routes.new}
            editUrl={list2Routes.edit}
            fireCollapse={fireCollapse}
            reduceHeight={240} // Makes the height of the list 100vh minus this height. Defaults to 190 for PageLayoutDefault area.
          />
        }
        {!code1 &&
          <PageDefaultSegment>
            List 1 New
          </PageDefaultSegment>
        }
      </Box>
    </ListAndDetailSamplesMultipleListHeadingContainer>
  )
}
